module.exports = __webpack_public_path__ + "static/media/icon5.e125a844.svg";